import Rule from './Rule';
import ValidationError from '../../exceptions/ValidationError';

// AIM-approved special character set only: ! # $ % & ' ( ) * + , - . / : ; < = > ? @ [ ] ^ _ { | } ~
const specialCharRegex = /[!#$%&'()*+,\-./:;<=>?@[\]^_{|}~]/;

export default class SpecialCharRule extends Rule {
  apply(value) {
    if (specialCharRegex.test(value)) {
      return Promise.resolve(this.message);
    }

    return Promise.reject(new ValidationError(this.message));
  }
}
